<template>
    <span v-if="gateway === 'ADMIN'" class="badge badge-danger mr-sm-2">{{gateway}}</span>
    <span v-else-if="gateway === 'USER_APP'" class="badge badge-info mr-sm-2">{{gateway}}</span>
    <span v-else class="badge badge-dark mr-sm-2">{{gateway}}</span>
</template>


<script>
  export default {
    name: 'GatewayRender',
    props: ['gateway']
  }
</script>
